export default __webpack_public_path__ + "static/RobotoMono-600-bbbf6951525a78fff340f2c42c3ba853.woff";